import { useEffect, useState } from "react";
import ButtonIconH from "../../components/ButtonIconH";
import InputData from "../../components/InputData";
import Dropdown from "../../components/Dropdown";
import CheckBox from "../../components/CheckBox";
import PopupCP from "../../support-extra/components/PopupCP";
import "../css/CompanyScreen.css";
import { provinceOptions } from "../../js/utils";
import { post } from "../utils/api";
import { userData } from "../../js/utils";

import "../css/EmpresasOpticas.css";

const tokenSesion = userData ? userData.token : "";

export default function CompanyScreen(props) {
  const [idEmpresa, setIdEmpresa] = useState(props.companyId);
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [NIF, setNIF] = useState("");
  const [CCC, setCCC] = useState("");
  const [direccion, setDirecion] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [localidad, setLocalidad] = useState("");
  const [provincia, setProvincia] = useState("");
  const [telefonoFijo, setTelefonoFijo] = useState("");
  const [telefonoMovil, setTelefonoMovil] = useState("");
  const [web, setWeb] = useState("");
  const [email, setEmail] = useState("");
  const [franquiciado, setFranquiciado] = useState(false);
  const [IBAN, setIBAN] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorCP, setErrorCP] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [originalData, setOriginalData] = useState(null);

  const [showPopupCP, setShowPopupCP] = useState(false);
  const [cpPopupAddress, setCPPopupAddress] = useState("");
  const [cpPopupCity, setCPPopupCity] = useState("");

  useEffect(() => {
    if (errorCP) {
      props.createPopupQuestion(
        "Por favor, revise el código postal.",
        () => {
          const el = document.getElementById("codigo_postal");
          if (el) {
            el.focus();
          }
          setErrorCP(false);
          props.removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  }, [errorCP]);

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        const nifInput = document.getElementById("nif");
        // Asegúrate de hacer focus al input o elemento interactivo
        if (nifInput) nifInput.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect(() => {
    async function cargarEmpresa() {
      setIsLoading(true);
      setIdEmpresa(props.companyId);

      if (props.companyId !== -1) {
        let bodyJson = { token: tokenSesion, idEmpresa: props.companyId };

        let json_empresa = await post(
          "Configuracion/ObtenerEmpresa.php",
          bodyJson,
        );

        if (json_empresa) {
          const empresaData = {
            nombreEmpresa: json_empresa.nombre_empresa,
            NIF: json_empresa.NIF,
            CCC: json_empresa.ccc,
            direccion: json_empresa.direccion,
            codigoPostal: json_empresa.codigo_postal,
            localidad: json_empresa.localidad,
            provincia: json_empresa.provincia,
            telefonoFijo: json_empresa.telefono_fijo,
            telefonoMovil: json_empresa.telefono_movil,
            web: json_empresa.web,
            email: json_empresa.email,
            franquiciado: Boolean(json_empresa.franquiciado),
            IBAN: json_empresa.IBAN,
          };

          setNombreEmpresa(json_empresa.nombre_empresa);
          setNIF(json_empresa.NIF);
          setCCC(json_empresa.ccc);
          setDirecion(json_empresa.direccion);
          setCodigoPostal(json_empresa.codigo_postal);
          setLocalidad(json_empresa.localidad);
          setProvincia(json_empresa.provincia);
          setTelefonoFijo(json_empresa.telefono_fijo);
          setTelefonoMovil(json_empresa.telefono_movil);
          setWeb(json_empresa.web);
          setEmail(json_empresa.email);
          setFranquiciado(Boolean(json_empresa.franquiciado));
          setIBAN(json_empresa.IBAN);

          setOriginalData(empresaData);
        } else {
          setNombreEmpresa("");
          setNIF("");
          setCCC("");
          setDirecion("");
          setCodigoPostal("");
          setLocalidad("");
          setProvincia("");
          setTelefonoFijo("");
          setTelefonoMovil("");
          setWeb("");
          setEmail("");
          setFranquiciado(false);
          setIBAN("");
        }
      } else {
        setNombreEmpresa("");
        setNIF("");
        setCCC("");
        setDirecion("");
        setCodigoPostal("");
        setLocalidad("");
        setProvincia("");
        setTelefonoFijo("");
        setTelefonoMovil("");
        setWeb("");
        setEmail("");
        setFranquiciado(false);
        setIBAN("");

        const newCompanyData = {
          nombreEmpresa: "",
          NIF: "",
          CCC: "",
          direccion: "",
          codigoPostal: "",
          localidad: "",
          provincia: "",
          telefonoFijo: "",
          telefonoMovil: "",
          web: "",
          email: "",
          franquiciado: false,
          IBAN: "",
        };

        setOriginalData(newCompanyData);
      }

      setIsLoading(false);
    }
    cargarEmpresa();
  }, [props.companyId]);

  const saveCompanyData = async () => {
    if (!minimunData()) {
      props.createPopupQuestion(
        `Los campos con (*) son obligatorios.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
    } else {
      let json_query = {
        token: tokenSesion,
        idEmpresa: idEmpresa,
        nombre_empresa: nombreEmpresa,
        NIF: NIF,
        ccc: CCC,
        direccion: direccion,
        codigo_postal: codigoPostal,
        localidad: localidad,
        provincia: provincia,
        telefono_fijo: telefonoFijo,
        telefono_movil: telefonoMovil,
        web: web,
        email: email,
        franquiciado: franquiciado,
        IBAN: IBAN,
      };

      let newIdEmpresa = -1;
      let error = "";

      // console.log(json_query);

      await post("Configuracion/GuardarEmpresa.php", json_query).then(
        (data) => {
          newIdEmpresa = data.idEmpresa;
          error = data.error;
        },
      );

      if (newIdEmpresa === -1) {
        // console.log(error);
        props.createPopupQuestion(
          `Ocurrió un error al grabar los datos.`,
          props.removePopupQuestion,
          null,
          "Entendido",
        );
        return false;
      } else {
        // Avisamos al padre que se guardó correctamente
        if (props.onSave) {
          props.onSave(newIdEmpresa);
        }
        return true;
        // Cerramos el poppup
        //props.closeFunction();
      }
    }
  };

  const discardChanges = () => {
    if (originalData) {
      setNombreEmpresa(originalData.nombreEmpresa);
      setNIF(originalData.NIF);
      setCCC(originalData.CCC);
      setDirecion(originalData.direccion);
      setCodigoPostal(originalData.codigoPostal);
      setLocalidad(originalData.localidad);
      setProvincia(originalData.provincia);
      setTelefonoFijo(originalData.telefonoFijo);
      setTelefonoMovil(originalData.telefonoMovil);
      setWeb(originalData.web);
      setEmail(originalData.email);
      setFranquiciado(originalData.franquiciado);
      setIBAN(originalData.IBAN);
    } else {
      // si es nueva empresa, limpiar todo
      setNombreEmpresa("");
      setNIF("");
      setCCC("");
      setDirecion("");
      setCodigoPostal("");
      setLocalidad("");
      setProvincia("");
      setTelefonoFijo("");
      setTelefonoMovil("");
      setWeb("");
      setEmail("");
      setFranquiciado(false);
      setIBAN("");
    }

    props.closeFunction(); // cerrar popup
  };

  const hasChanges = () => {
    if (!originalData) return false;

    return (
      nombreEmpresa !== originalData.nombreEmpresa ||
      NIF !== originalData.NIF ||
      CCC !== originalData.CCC ||
      direccion !== originalData.direccion ||
      codigoPostal !== originalData.codigoPostal ||
      localidad !== originalData.localidad ||
      provincia !== originalData.provincia ||
      telefonoFijo !== originalData.telefonoFijo ||
      telefonoMovil !== originalData.telefonoMovil ||
      web !== originalData.web ||
      email !== originalData.email ||
      franquiciado !== originalData.franquiciado ||
      IBAN !== originalData.IBAN
    );
  };

  const handleClose = () => {
    if (hasChanges()) {
      props.createPopupQuestion(
        `Hay cambios sin guardar. ¿Seguro que quieres salir sin guardar?`,
        async () => {
          discardChanges();
          props.removePopupQuestion();
        },
        props.removePopupQuestion,
        "Sí",
        "No",
      );
    } else {
      props.closeFunction();
    }
  };

  const minimunData = () => {
    return (
      // Usa ?.trim() para evitar crasheos si la variable es null/undefined
      nombreEmpresa?.trim() &&
      NIF?.trim() &&
      direccion?.trim() &&
      codigoPostal?.trim() &&
      localidad?.trim() &&
      provincia?.trim() &&
      (telefonoFijo?.trim() || telefonoMovil?.trim())
    );
  };

  const showPopupCPDialog = (show, address, city) => {
    setCPPopupAddress(address);
    setCPPopupCity(city);
    setShowPopupCP(show);
  };

  const onAcceptCP = (fullAddress) => {
    setCodigoPostal(fullAddress.postalCode);
    showPopupCPDialog(false, "", "");
  };

  /*if (!props.show) {
    return <></>;
  }*/

  if (isLoading) {
    return <div className="spinner" />;
  }

  return (
    <div className="popup-container popup-normal popup-settings-company">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">Datos de empresa</div>
          <img
            src="images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={() => {
              handleClose();
            }}
          />
        </div>
        <div className="popup-body">
          <div className="company-section-content-data">
            <div className="company-data-field-row-extra">
              <div className="company-data-field d-company-small">
                <span className="label">NIF (*)</span>
                <InputData
                  id="nif"
                  tabIndex={1}
                  type="type-only-charnumbers"
                  size={6}
                  input={NIF}
                  onChange={(e) => {
                    setNIF(e);
                  }}
                ></InputData>
              </div>
              <div className="company-data-field d-company-small">
                <span className="label">Franquiciado</span>
                <CheckBox
                  id="franquiciado"
                  tabIndex={2}
                  active={franquiciado}
                  onClick={() => {
                    setFranquiciado(!franquiciado);
                  }}
                ></CheckBox>
              </div>
              <div className="company-data-field d-company-small">
                <span className="label">CCC</span>
                <InputData
                  id="ccc"
                  tabIndex={3}
                  type="type-only-charnumbers"
                  size={6}
                  input={CCC}
                  onChange={(e) => {
                    setCCC(e);
                  }}
                ></InputData>
              </div>
            </div>
            <div className="company-data-field-row">
              <div className="company-data-field d-company-large">
                <span className="label">Razón social (*)</span>
                <InputData
                  id="nombre_empresa"
                  tabIndex={4}
                  size={6}
                  input={nombreEmpresa}
                  onChange={(e) => {
                    setNombreEmpresa(e);
                  }}
                ></InputData>
              </div>
            </div>
            <div className="company-data-field-row">
              <div className="company-data-field d-company-large">
                <span className="label">Dirección (*)</span>
                <InputData
                  id="direccion"
                  tabIndex={5}
                  type="type-alphanum-ext"
                  size={6}
                  input={direccion}
                  onChange={(e) => {
                    setDirecion(e);
                  }}
                ></InputData>
              </div>
            </div>
            <div className="company-data-field-row">
              <div className="company-data-field d-company-large">
                <span className="label">Localidad (*)</span>
                <InputData
                  id="localidad"
                  tabIndex={6}
                  type="type-alpha"
                  size={6}
                  input={localidad}
                  onChange={(e) => {
                    setLocalidad(e);
                  }}
                ></InputData>
              </div>
            </div>
            <div className="company-data-field-row-extra">
              <div className="company-data-field d-company-small">
                <span className="label">Código postal (*)</span>
                <InputData
                  id="codigo_postal"
                  tabIndex={7}
                  type="type-cp"
                  maxLength={5}
                  size={6}
                  input={codigoPostal}
                  onChange={(e) => {
                    setCodigoPostal(e);
                  }}
                  onMalformed={() => setErrorCP(true)}
                  error={errorCP}
                  icon="/images/link.svg"
                  onClick={() => showPopupCPDialog(true, direccion, localidad)}
                ></InputData>
              </div>
              <div className="company-data-field-extra d-company-large">
                <span className="label">Provincia (*)</span>
                <Dropdown
                  id="provincia"
                  tabIndex={8}
                  disabled={false}
                  optionList={provinceOptions}
                  size={0}
                  op={provincia}
                  onChange={(e) => {
                    setProvincia(e.text);
                  }}
                ></Dropdown>
              </div>
            </div>
            <div className="company-data-field-row-extra">
              <div className="company-data-field d-company-small">
                <span className="label">Teléfono (*)</span>
                <InputData
                  id="telefono_fijo"
                  tabIndex={9}
                  type="type-phone"
                  size={6}
                  input={telefonoFijo}
                  onChange={(e) => {
                    setTelefonoFijo(e);
                  }}
                ></InputData>
              </div>
              <div className="company-data-field d-company-large">
                <span className="label">Email</span>
                <InputData
                  id="email"
                  tabIndex={10}
                  type="type-email"
                  size={6}
                  input={email}
                  onChange={(e) => {
                    setEmail(e);
                  }}
                  onMalformed={() => setErrorEmail(true)}
                  error={errorEmail}
                ></InputData>
              </div>
            </div>
            <div className="company-data-field-row-extra">
              <div className="company-data-field d-company-small">
                <span className="label">Móvil (*)</span>
                <InputData
                  id="email"
                  tabIndex={11}
                  type="type-phone"
                  size={6}
                  input={telefonoMovil}
                  onChange={(e) => {
                    setTelefonoMovil(e);
                  }}
                ></InputData>
              </div>
              <div className="company-data-field d-company-large">
                <span className="label">Web</span>
                <InputData
                  id="web"
                  tabIndex={12}
                  size={6}
                  input={web}
                  onChange={(e) => {
                    setWeb(e);
                  }}
                ></InputData>
              </div>
            </div>
            <div className="company-data-field-row">
              <div className="company-data-field d-company-large">
                <span className="label">IBAN</span>
                <InputData
                  id="IBAN"
                  tabIndex={13}
                  type="type-only-charnumbers"
                  size={6}
                  input={IBAN}
                  onChange={(e) => {
                    setIBAN(e);
                  }}
                ></InputData>
              </div>
            </div>
          </div>
          <div className="popup-row-buttons-container">
            <div className="popup-row-buttons">
              <ButtonIconH
                text="Cancelar"
                onClick={() => {
                  handleClose();
                }}
              />
              <ButtonIconH
                text="Guardar"
                onClick={() => {
                  props.createPopupQuestion(
                    `¿Desea guardar los cambios realizados en esta empresa?`,
                    async () => {
                      const guardadoExitoso = await saveCompanyData();

                      if (guardadoExitoso) {
                        props.removePopupQuestion();
                        props.closeFunction();
                      }
                    },
                    props.removePopupQuestion,
                    "Sí",
                    "No",
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <PopupCP
        show={showPopupCP}
        direccion={cpPopupAddress}
        localidad={cpPopupCity}
        onAccept={(fullAddress) => onAcceptCP(fullAddress)}
        onCancel={() => showPopupCPDialog(false, "", "")}
      />
    </div>
  );
}
